module.exports = __webpack_public_path__ + "static/GorditaRegular-Italic-dc4993a1e1ad268b2f6a395155a1a786.woff2";